import axios from 'axios';
import authHeader from './services/auth-header';
/* import TokenService from './services/token-service'; */
import Swal from 'sweetalert2/dist/sweetalert2'
import i18n from './i18n.js';

// V produkci vždy relativně na stejnou doménu – dřív natvrdo https://waipal.com/api, takže na
// www.waipal.com a na stagingu šly requesty na jinou doménu bez cookies (419/401, nefungoval ani přepínač jazyka).
// VITE_API_URL slouží jen pro lokální vývoj.
let baseURL = import.meta.env.VITE_API_URL;
if(!baseURL || import.meta.env.PROD === true) {
    baseURL = '/api';
}

let myAxios = axios.create({
    baseURL: baseURL,
    headers: authHeader(),
    maxBodyLength: 100 * 1024 * 1024,
    maxContentLength: 100 * 1024 * 1024,
});


// Pojistka k serverovému Handleru: hlášky, které nejsou pro uživatele – technické detaily a výchozí
// anglické texty frameworku – nahradíme obecnou „Vyskytla se chyba“
const TECHNICAL_MESSAGE = new RegExp([
    'SQLSTATE', 'Exception', 'No query results', 'Call to ', 'Undefined ', '::', 'App\\\\(Models|Http|Services)',
    'Server Error', 'Unauthenticated\\.', 'CSRF token mismatch', 'Too Many Attempts', 'This action is unauthorized',
    '^Not Found\\.?$', 'The given data was invalid', 'method is not supported', 'Whoops',
].join('|'), 'i');

function isUserFriendlyMessage(message, status) {
    if (typeof message !== 'string' || message.trim() === '') return false;
    // 5xx nikdy neobsahuje text určený uživateli (aplikace 5xx s vlastní hláškou nevrací)
    if (status >= 500) return false;
    return !TECHNICAL_MESSAGE.test(message);
}

myAxios.interceptors.response.use(function (response) {
    if (response.status == 200 && response.data && response.data.message && response.data.message.length > 0) {
        Swal.fire({
            icon: 'success',
            text: response.data.message
        });
    }

    return response;
}, async function (error) {
    // Zrušený request (AbortController) není chyba, kterou by měl uživatel vidět
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }

    let errorText;

    if (error.response) {
        const response = error.response;
        const code = response.status;
        let data = response.data;
        // Stahování (responseType: 'blob') dostane i chybovou JSON odpověď jako Blob – přečteme z ní hlášku
        if (data instanceof Blob && data.type.includes('json')) {
            try {
                data = JSON.parse(await data.text());
            } catch (e) {
                data = null;
            }
        }
        const errorMessage = data?.message;

        if (code === 413) {
            // 413 vrací nginx jako HTML stránku ještě před Laravelem – JSON message v ní není
            errorText = i18n.global.t('file.fileTooLarge');
        } else if (isUserFriendlyMessage(errorMessage, code)) {
            errorText = errorMessage;
        } else {
            // Odpověď bez JSON message (HTML chybová stránka 500/502/504, blob u stahování…)
            // nebo s technickou/nepřeloženou hláškou
            errorText = i18n.global.t('general.errorUnexpected');
        }
    } else if (error.request) {
        // Request odešel, ale odpověď nepřišla (výpadek sítě, timeout, CORS)
        errorText = i18n.global.t('general.errorNetwork');
    }

    if (errorText) {
        Swal.fire({
            icon: 'error',
            text: errorText
        });
    }

    return Promise.reject(error);
});


export default myAxios;
